import { ODataSelect } from "@iconics/core";

export class DataHubCredentials extends ODataSelect
{
    public Id = 0;
    public Name = "";
    public DisplayName = "";
    public ConnectionString = "";
    public AccessKey = "";
    public "@odata.etag" = "";
    
    override toSelect(): string
    {
        return ''
    }
}
